/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Credit usage for the current billing period
 * @export
 * @interface GetBillingCreditUsagePeriod200Response
 */
export interface GetBillingCreditUsagePeriod200Response {
    /**
     * Total credits used in the current billing period
     * @type {number}
     * @memberof GetBillingCreditUsagePeriod200Response
     */
    total: number;
    /**
     * Start of the current billing period
     * @type {Date}
     * @memberof GetBillingCreditUsagePeriod200Response
     */
    periodStart?: Date;
    /**
     * End of the current billing period
     * @type {Date}
     * @memberof GetBillingCreditUsagePeriod200Response
     */
    periodEnd?: Date;
}

/**
 * Check if a given object implements the GetBillingCreditUsagePeriod200Response interface.
 */
export function instanceOfGetBillingCreditUsagePeriod200Response(value: object): value is GetBillingCreditUsagePeriod200Response {
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function GetBillingCreditUsagePeriod200ResponseFromJSON(json: any): GetBillingCreditUsagePeriod200Response {
    return GetBillingCreditUsagePeriod200ResponseFromJSONTyped(json, false);
}

export function GetBillingCreditUsagePeriod200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBillingCreditUsagePeriod200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'periodStart': json['periodStart'] == null ? undefined : (new Date(json['periodStart'])),
        'periodEnd': json['periodEnd'] == null ? undefined : (new Date(json['periodEnd'])),
    };
}

export function GetBillingCreditUsagePeriod200ResponseToJSON(json: any): GetBillingCreditUsagePeriod200Response {
    return GetBillingCreditUsagePeriod200ResponseToJSONTyped(json, false);
}

export function GetBillingCreditUsagePeriod200ResponseToJSONTyped(value?: GetBillingCreditUsagePeriod200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total': value['total'],
        'periodStart': value['periodStart'] == null ? undefined : ((value['periodStart']).toISOString()),
        'periodEnd': value['periodEnd'] == null ? undefined : ((value['periodEnd']).toISOString()),
    };
}

